'use client'
import {
  useUi
} from "./chunk-Y3GT52GT.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/Calendar/DayPicker.tsx
import { DayPicker as Picker } from "react-day-picker";
import { arSA, enGB, fr } from "date-fns/locale";
import { useRouter } from "@wbk/config";
import styles from "react-day-picker/dist/style.module.css";
import { jsx } from "react/jsx-runtime";
var DayPicker = (_a) => {
  var _b = _a, { classNames } = _b, props = __objRest(_b, ["classNames"]);
  const { locale } = useRouter();
  const { dir } = useUi();
  return /* @__PURE__ */ jsx(
    Picker,
    __spreadValues({
      classNames: __spreadValues(__spreadProps(__spreadValues({}, styles), {
        root: `${styles.root} !w-full !m-0`,
        table: `${styles.table} !w-full !max-w-full`,
        month: `${styles.month} !w-full`,
        head_cell: `${styles.head_cell} !w-28 !p-1 !text-text-secondary`,
        caption: `${styles.caption} !pb-2`,
        caption_label: `${styles.caption_label} !px-0`,
        cell: `${styles.cell} !p-0`,
        nav_button: `${styles.nav_button} disabled:!pointer-events-none disabled:!cursor-default disabled:!opacity-25 !mx-1 !p-2 hover:!bg-primary/10 focus:!bg-primary/20`,
        button_reset: "!rounded-S",
        button: "!py-2 !m-px enabled:!cursor-pointer enabled:hover:!bg-primary/30 enabled:focus:!bg-primary/30 !rounded-S disabled:!opacity-25 disabled:!cursor-not-allowed",
        day: "!w-full",
        day_selected: "!text-primary-contrast !bg-primary enabled:hover:!bg-primary/80 !text-primary enabled:focus:!bg-primary/80 enabled:focus:!bg-primary/80",
        day_range_start: "!bg-primary !text-primary-contrast ltr:!rounded-r-none rtl:!rounded-l-none",
        day_range_end: "!bg-primary !text-primary-contrast ltr:!rounded-l-none rtl:!rounded-r-none",
        day_range_middle: "!rounded-none !bg-primary/40 !text-primary-contrast",
        day_outside: "!opacity-100"
      }), classNames),
      dir,
      locale: (locale == null ? void 0 : locale.startsWith("ar")) ? arSA : (locale == null ? void 0 : locale.startsWith("fr")) ? fr : enGB,
      weekStartsOn: 0
    }, props)
  );
};
var DayPicker_default = DayPicker;

export {
  DayPicker_default
};
//# sourceMappingURL=chunk-7JW3DEAI.mjs.map